<div
  class="css-pill"
  [class.css-pill-medium]="size === 'medium'"
  [style.color]="statusPill?.primaryColor"
  [style.background-color]="statusPill?.secondaryColor"
  [style.border-color]="statusPill?.primaryColor">
  {{ statusPill?.name }}
</div>
